import React from "react";

export const Stat = (props) => {
  const { title, value, size, info } = props;

  let style = {};
  if (size && size === "sm") {
    style = { fontSize: ".8em" };
  } else {
    // className = " text-center";
  }
  return (
    <div className='text-center' style={style}>
      <div className='d-flex justify-content-center'>
        <div className={"text-muted"} style={{ fontSize: ".9em", fontWeight: "bold" }}>
          {title}
        </div>
        {info ? <div className='ms-2'>{info}</div> : null}
      </div>
      <div className={"text-dark"} style={{ fontSize: "1.4em" }}>
        {Math.trunc(value)} ms
      </div>
    </div>
  );
};
